<style lang="less">
.drop-modal{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    visibility: hidden;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
    width: 100vw;
    height: 100vh;
    background:rgba(255,255,255, 0.9);
    color: #2254f4;
    opacity: 0;
    transition: opacity 0.3s, visibility 0.3s;
    p {
        font-size: 48px;
        font-weight: bold;
        line-height: 67px;
    }
    span {
        font-size: 18px;
        line-height: 25px;
    }
}
.drop-modal--show {
    visibility: visible;
    opacity: 1;
}
</style>

<template>
    <div class="drop-modal" :class="{ 'drop-modal--show': show }">
        <p>将图片拖至此处</p>
        <span>{{desc}}</span>
    </div>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        desc: {
            type: String,
            default: ''
        }
    }
};
</script>
